export interface FuelSpecsStoreState {
  readonly isFetchingDefaultFuelSpecs: boolean;
  readonly fetchError: string | undefined;
  readonly lastFetched: number | undefined;
  readonly fuelSpecByGradeAndIso: Record<string, string>;
}

export const INITIAL_FUEL_SPEC_STORE_STATE: FuelSpecsStoreState = {
  isFetchingDefaultFuelSpecs: false,
  fetchError: undefined,
  lastFetched: undefined,
  fuelSpecByGradeAndIso: {},
};
